import React, { FC, memo } from 'react'
import { getEnv, toastLayer } from '@utils'
import { Icon } from '@cps'
import './index.scss'

let count = 0
let timer: NodeJS.Timeout
const { isDebug } = getEnv()

const PowerByEShine: FC = () => {
  // 处理点击事件
  const handleClick = () => {
    count++
    if (count === 10) {
      if (!isDebug) {
        localStorage.setItem('isDebug', '1')
        toastLayer.success({
          content: '刷新后开启debug',
          duration: 1000,
        })
      } else {
        localStorage.removeItem('isDebug')
        toastLayer.error({
          content: '刷新后关闭debug',
          duration: 1000,
        })
      }
      count = 0
      if (timer) {
        clearTimeout(timer)
        timer = null
      }
    } else {
      if (timer) {
        clearTimeout(timer)
        timer = null
      }
      // 10秒后重置
      timer = setTimeout(() => {
        count = 0
      }, 10000)
    }
  }
  return (
    <div className='power-by-eshine' data-cypid='power-by-eshine' onClick={handleClick}>
      {
        window.ODMINFO ? <Icon name={window.ODMINFO.key} /> : <Icon name='eshine-us' />
      }
    </div>
  )
}
export default memo(PowerByEShine)
